var YouLi = YouLi ? YouLi : {};
YouLi.CreditCardPaymentForm = YouLi.CreditCardPaymentForm ? YouLi.CreditCardPaymentForm : {};
YouLi.CreditCardPaymentForm.CyberSource = YouLi.CreditCardPaymentForm.CyberSource ? YouLi.CreditCardPaymentForm.CyberSource : {};

(function (YouLi) {
    (function (CreditCardPaymentForm) {
        (function (CyberSource) {
            YouLi.CreditCardPaymentForm.CyberSource.InitialiseCyberSource = function () {
                var captureContext = YouLi.CreditCardPaymentForm.CyberSourceJWT;

                var myStyles = {
                    'input': {
                        'font-size': '14px',
                        'font-family': 'helvetica, tahoma, calibri, sans-serif',
                        'color': '#555'
                    },
                    ':disabled': {'cursor': 'not-allowed'},
                    'valid': {'color': '#555'},
                    'invalid': {'color': '#a94442'}
                };

                var flex = new Flex(captureContext);
                YouLi.CreditCardPaymentForm.CyberSourceForm = flex.microform({styles: myStyles});
                var number = YouLi.CreditCardPaymentForm.CyberSourceForm.createField('number', {placeholder: 'Card number'});
                var securityCode = YouLi.CreditCardPaymentForm.CyberSourceForm.createField('securityCode', {placeholder: 'CVV'});

                number.load('#p-card-number');
                securityCode.load('#p-cvv');

                // set up validation of form for billing details
                YouLi.CreditCardPaymentForm.RefreshValidators();
            };

            YouLi.CreditCardPaymentForm.CyberSource.CyberSourceRequestCardNonce = function () {

                // Validate the form before anything else
                let $form = $('#GenericPaymentForm');
                $form.validateBootstrap();
                if (!$form.valid()) {
                    YouLi.Common.UI.ScrollToTopModal("GenericPaymentFormDialog");
                    YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));
                    return;
                }

                var expMonth = document.querySelector('#p-expiration-month');
                var expYear = document.querySelector('#p-expiration-year');

                var options = {
                    expirationMonth: expMonth.value,
                    expirationYear: expYear.value
                };

                YouLi.CreditCardPaymentForm.CyberSourceForm.createToken(options, function (error, token) {
                    YouLi.CreditCardPaymentForm.ClearErrorInModal();

                    if (error) {
                        YouLi.CreditCardPaymentForm.ShowErrorInModal(error.message, error.reason);

                        YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                        return;
                    }

                    //document.getElementById('card-nonce').value = token;

                    return YouLi.CreditCardPaymentForm.CheckForOverpayment()
                        .then(() => {

                            YouLi.CreditCardPaymentForm.MakePaymentFunction(token, "cybersource");

                        }).catch((errorObject) => {
                            console.error('Error:', errorObject.message);

                            YouLi.Common.UI.HideButtonLoading($("#p-creditcard"));

                            if (!errorObject.errorHandled) {
                                YouLi.CreditCardPaymentForm.OnPageErrorHandlerFunction("", moment());
                            }
                        });
                });
            };
        }(YouLi.CreditCardPaymentForm.CyberSource ? YouLi.CreditCardPaymentForm.CyberSource : {}));
    }(YouLi.CreditCardPaymentForm ? YouLi.CreditCardPaymentForm : {}));
}(YouLi ? YouLi : {}));